import classnames from 'classnames';
import { ChangeEvent } from 'react';

import { CheckIcon } from '../../assets/svgs';
import { cn } from '../../utils';

interface Props {
  className?: string;
  inputKey: string;
  value: boolean;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
}

const Checkbox = ({ className, inputKey, value, onChange, disabled = false }: Props) => {
  function onChangeInput(e: ChangeEvent<HTMLInputElement>) {
    if (!onChange || disabled) return;
    onChange(e.target?.checked);
  }

  return (
    <div className={cn('h-4 w-4', className)}>
      <label
        htmlFor={inputKey}
        className={classnames('flex h-4 w-4 items-center justify-center rounded border border-border-primary', {
          'border-system100 bg-system100': value,
          'cursor-not-allowed opacity-50': disabled
        })}
      >
        {value && <CheckIcon className="[&_path]:fill-white" />}
      </label>
      <input id={inputKey} type="checkbox" checked={value} onChange={onChangeInput} hidden disabled={disabled} />
    </div>
  );
};

export default Checkbox;
